import { Component, AfterViewInit, OnDestroy, inject } from '@angular/core';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionsService } from 'app/shared/services/user-sessions/user-sessions.service';

@Component({
  selector: 'app-login-redirect',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  imports: [],
  standalone: true,
})
export class AuthComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject();
  private userSession: UserSessionsService = inject(UserSessionsService);
  private oidc: OidcClientService = inject(OidcClientService);
  constructor() {}

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    if (!this.oidc.inIframe()) {
      this.oidc
        .getUserComputed()
        .pipe(takeUntil(this.destroy$))
        .subscribe((user) => {
          if (user) {
            if (!this.oidc.isExpired()) {
              sessionStorage.removeItem('isExistingEmployee');
              sessionStorage.removeItem('userProfileErrorMsg');
              this.userSession.getUserProfile(user.id_token);
            } else {
              this.userSession.logout();
            }
          } else {
            this.oidc
              .completeSignIn()
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (signedInUser) => {
                  if (signedInUser) {
                    const user = this.oidc.getUser();
                    if (user) {
                      this.userSession.getUserProfile(user.id_token);
                    } else {
                      this.userSession.logout();
                    }
                  } else {
                    this.userSession.logout();
                  }
                },
                error: (error) => {
                  if (error.name === 'ErrorResponse') {
                    console.error('ERROR:', JSON.stringify(error));
                    this.userSession.logout();
                  } else {
                    this.oidc.signIn();
                  }
                },
              });
          }
        });
    }
  }
}
